import gmx_zMixins         from '../../../../../../includes/Jmixins/zMixins'

// Locally declared common Data-Props & SVG Drawing Support
import lmx_LocalValues          from './set_LocalValues'
import lmx_Watching             from './Watching'
import lmx_Events               from './Events'

import lmx_Elements from './Draw_Elements.mixin'
import lmx_DadarChart from './Draw_DadarChart.mixin'

export default {
  mixins: [
    gmx_zMixins, 

    // Local Mixins
    lmx_LocalValues,
    lmx_Watching,
    lmx_Events,
    
    // Charting Mixins
    lmx_Elements,
    lmx_DadarChart, 

  ],
}
